import { createAsyncThunk } from '@reduxjs/toolkit';

import { apiSahClients, apiSahExternalBudgets } from '~constants/api';

import { get, post, put, remove, upload } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'sah-external-budgets';

type FileUploadParams = {
  file: File;
  setProgress?: (value: number) => void;
};

const config = [
  { actionType: 'getAll', apiPath: `${apiSahExternalBudgets}`, method: get },
  {
    actionType: 'getOne',
    apiPath: (params: Params) => `${apiSahClients}/${params.client_id}/external/budgets`,
    method: get,
  },
  { actionType: 'create', apiPath: `${apiSahExternalBudgets}`, method: post },
  { actionType: 'update', apiPath: (params: Params) => `${apiSahExternalBudgets}/${params.id}`, method: put },
  { actionType: 'deleteOne', apiPath: (params: Params) => `${apiSahExternalBudgets}/${params.id}`, method: remove },
  // TAV-2601 / TAV-2602 — irreversible SA trigger actions. `{uuid}` is the TurnPoint
  // client_sah_budgets.id (the row's backendId), not sah_budget_id.
  {
    actionType: 'rollover',
    apiPath: (params: Params) => `${apiSahExternalBudgets}/${params.id}/rollover`,
    method: post,
  },
  {
    actionType: 'electToReturn',
    apiPath: (params: Params) => `${apiSahExternalBudgets}/${params.id}/elect-to-return`,
    method: post,
  },
];

export const uploadFile = createAsyncThunk(
  `sah-external-budgets-upload/upload`,
  async ({ file, setProgress }: FileUploadParams, { rejectWithValue }) => {
    try {
      return await upload(
        `${apiSahExternalBudgets}/upload`,
        file,
        (progress) => {
          if (typeof progress === 'number') {
            setProgress?.(progress);
          }
        },
        undefined,
        undefined,
        true,
      );
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

export const { deleteOne, getAll, getOne, create, update, rollover, electToReturn } = createThunks(typePrefix, config);
